import supportConfig from '../../../../config/whatsappSupport.json'

export const waUrlBuilder = (): string => {
    return `${supportConfig.whatsappUrl}/${supportConfig.PhoneNumber}?text=${supportConfig.PredefinedMessage}`;
}

export const waUrlBuilderComercial = (): string => {
    return `${supportConfig.whatsappUrl}/${supportConfig.ComercialPhoneNumber}?text=${supportConfig.PredefinedMessageComercial}`;
}